import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import ContentManager from "./Curation/ContentManager";
import { ContentManagerAccess } from "./Curation/Auth0/ContentManagerAccess";

const RootRedirect: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Preserve OAuth callback parameters when redirecting
        const search = window.location.search;
        void navigate(`/access-content-manager${search}`, { replace: true });
    }, [navigate]);

    return null;
};

const App = () => {
    return (
        <Router>
            <div className="App">
                <main className="App-content">
                    <Routes>
                        <Route path="/" element={<RootRedirect />} />
                        <Route path="/content-manager/:listId" element={<ContentManager />} />
                        <Route path="/access-content-manager" element={<ContentManagerAccess />} />
                    </Routes>
                </main>
            </div>
        </Router>
    );
};

export default App;
